<ion-header>
  <ion-toolbar>
    <ion-title>{{i18n.tr("[en]Audio Recording")}}</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()"
        >{{i18n.tr("[en]Cancel")}}</ion-button
        >
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
    <div class="status-display">
      <div class="timer">{{ durationDisplay }}</div>

      @if (!isRecording && !recordedAudio && !isTranscribing) {
        <div
          class="prompt"
          >
          {{i18n.tr("[en]Press the microphone to start recording")}}
        </div>
      }

      @if (isRecording) {
        <div class="prompt">
          <ion-spinner name="pulse"></ion-spinner>
          <span>{{i18n.tr("[en]Recording...")}}</span>
        </div>
      }

      @if (isTranscribing) {
        <div class="prompt">
          <ion-spinner name="crescent"></ion-spinner>
          <span>{{i18n.tr("[en]Transcribing, please wait.")}}</span>
        </div>
      }
    </div>

    @if (!isRecording && !isTranscribing && recordedAudio) {
      <div
        class="review-area"
        >
        <div class="playback-controls">
          <ion-button fill="clear" (click)="playAudio()">
            <ion-icon
              slot="icon-only"
              class="play-icon"
              [name]="isPlaying ? 'pause-circle' : 'play-circle'"
            ></ion-icon>
          </ion-button>
          <ion-range
            [value]="audioProgress * 100"
            (ionKnobMoveEnd)="seekAudio($event)"
            min="0"
            max="100"
          ></ion-range>
        </div>
        <ion-label position="stacked">{{i18n.tr("Opgenomen tekst")}}</ion-label>
        <textarea
          class="final-text"
          [(ngModel)]="transcribedText"
          rows="4"
          [placeholder]="i18n.tr('Opgenomen tekst verschijnt hier...')"
        ></textarea>
        @if (recordedAudio && !isRecording) {
          <ion-button
            class="save-button"
            (click)="saveAndClose()"
            [disabled]="isTranscribing"
            expand="block"
            >
            <ion-icon name="checkmark" slot="end"></ion-icon>
            {{i18n.tr("[en]Confirm")}}
          </ion-button>
        }
      </div>
    }
    @if (!keyboardOpen) {
      <ion-fab
        class="controls-container"
        vertical="bottom"
        horizontal="center"
        slot="fixed"
        >
        <ion-fab-button
          size="big"
          class="mic-button"
          (click)="isRecording ? stopRecording() : startRecording()"
          [color]="isRecording ? 'danger' : 'primary'"
          >
          <ion-icon [name]="isRecording ? 'stop' : 'mic'"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    }
  </ion-content>
